<template>
  <div>
    <v-row>
      <v-col cols="12" sm="10">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          outlined
          rounded
          dense
          hide-details
        ></v-text-field
      ></v-col>
      <v-col cols="12" sm="2">
        <physician-modal></physician-modal>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="physicians"
      :search="search"
      item-key="physicianId"
      class="alt-shading"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <physician-modal :physician="item"></physician-modal> </template
    ></v-data-table>
  </div>
</template>

<script>
import PhysicianModal from "./physician-modal";

export default {
  components: {
    PhysicianModal,
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "displayName",
        },
        { text: "NPI", value: "npi" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      search: "",
    };
  },
  computed: {
    physicians() {
      return this.$store.state.optionsModule.physicians || [];
    },
  },
};
</script>

<style lang="css" scoped>
.alt-shading >>> tr:nth-child(even) {
  background: #ccc;
}
</style>